const commentItems = [
  {
    name: '深夜追剧人',
    text: '夜猫电影院真的绝了！高清片源秒播不卡顿，再也不用忍受其他免费影院的转圈缓冲。每晚熬夜追剧必备，画质清晰流畅，已经推荐给身边所有朋友了！',
    rating: 5,
    time: '3天前',
    avatar: 'NC',
  },
  {
    name: '电影发烧友小陈',
    text: '片库太全了，从最新院线到经典老片应有尽有，高清影视体验完全不输付费平台。最重要的是不卡顿，这才是免费影院该有的样子！',
    rating: 5,
    time: '5天前',
    avatar: '小陈',
  },
  {
    name: '周末影迷',
    text: '用了大半年了，每日更新速度真的快，最新电影基本第一时间就能看到。高清画质在线观看体验很好，偶尔深夜追剧也完全不缓冲，真心推荐。',
    rating: 4,
    time: '1周前',
    avatar: '影迷',
  },
  {
    name: '通勤追剧达人',
    text: '手机上看也很流畅！地铁上追剧不卡顿真的太幸福了。高清电影免费在线观看还不用注册，打开就能看，这才是良心免费影院。',
    rating: 5,
    time: '2周前',
    avatar: '达人',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          观众评价
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          听听夜猫电影院的观众们怎么说
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100/70 border border-background-200/60 rounded-xl p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-heading font-bold text-primary-600">
                    {item.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {item.name}
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {item.time}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}